import globals from '@descope-ui/theme-globals';
import { getThemeRefs, useVar } from '@descope-ui/common/theme-helpers';
import { TextClass } from '@descope-ui/descope-text/class';
import { RecoveryCodesClass } from './component/RecoveryCodesClass';

const globalRefs = getThemeRefs(globals);
const vars = RecoveryCodesClass.cssVarList;
const textVars = TextClass.cssVarList;

const recoveryCodes = {
  [vars.hostMinWidth]: '190px',
  [vars.hostDirection]: globalRefs.direction,
  [vars.iconColor]: useVar(textVars.textColor),
  [vars.iconSize]: useVar(textVars.fontSize),
  [vars.iconGap]: '8px',
  [vars.bulletGap]: '0.35em',

  textAlign: {
    right: { [vars.textAlign]: 'flex-end' },
    left: { [vars.textAlign]: 'flex-start' },
    center: { [vars.textAlign]: 'center' },
  },

  _fullWidth: {
    [vars.hostWidth]: '100%',
  },
};

export default recoveryCodes;
export { vars };
